import { useState } from 'react'
import { Typography } from '@mui/material'
import { PreviousPendingRequest } from '../../ReceivementTypes'
import { actions } from '../../../swap-or-return/SwapOrReturnState'
import { useDispatch } from 'react-redux'
import PreviousPendingRequestCard from '../PreviousPendingRequestCard/PreviousPendingRequestCard'
import ConfirmOrRejectModal from 'src/features/base/components/ConfirmOrRejectModal'
import * as S from './PreviousPendingRequestForm.styles'

interface PreviousPendingRequestFormProps {
  supplierName: string
  previousPendingRequests: PreviousPendingRequest[]
  totalSelectedRequests: number
  setPostponePendingRequests: React.Dispatch<React.SetStateAction<boolean>>
  setIsResolvingRequests: React.Dispatch<React.SetStateAction<boolean>>
}

const PreviousPendingRequestForm: React.FC<PreviousPendingRequestFormProps> = (
  {
    supplierName, previousPendingRequests, totalSelectedRequests, setPostponePendingRequests, setIsResolvingRequests,
  },
) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const dispatch = useDispatch()

  const handleCheckboxChange = (requestId: number, isChecked: boolean) => {
    if (isChecked) {
      dispatch(actions.setSelectedIdToResolve(requestId))
      return
    }

    dispatch(actions.removeSelectedIdToResolve(requestId))
  }

  const closeConfirmModal = () => setShowConfirmModal(false)

  const postponePendingRequests = () => {
    closeConfirmModal()
    setPostponePendingRequests(true)
    dispatch(actions.setProperty({ property: 'swapOrReturnToResolveIds', value: [] }))
  }

  const formatQuantity = (qty: number) => `${qty.toString().padStart(2, '0')} ${qty > 1 ? 'selecionadas' : 'selecionada'}`

  const hasSelected = totalSelectedRequests > 0

  return (
    <S.Container>
      <S.SubTitle>
        <Typography variant='h6' fontWeight={600} mt={1}>Pendências anteriores</Typography>
        <S.Selected hasSelected={hasSelected}>{hasSelected ? formatQuantity(totalSelectedRequests) : 'nenhuma selecionada'}</S.Selected>
      </S.SubTitle>
      <S.SubTitle>
        <Typography><strong>Nome fornecedor:</strong> {supplierName}</Typography>
      </S.SubTitle>
      <S.ContainerCards>
        {previousPendingRequests.map((previousPendingRequest) => (
          <PreviousPendingRequestCard
            key={previousPendingRequest.requestId}
            previousPendingRequest={previousPendingRequest}
            onCheckboxChange={handleCheckboxChange}
          />
        ))}
      </S.ContainerCards>
      <S.ContainerButtons>
        <S.CustomButton
          title={`Resolver ${totalSelectedRequests > 1 ? 'pendências selecionadas' : 'pendência selecionada'}`}
          bgColor='confirm'
          hoverColor='confirmHover'
          letterColor='white'
          onClick={() => setIsResolvingRequests(true)}
          data-testid='resolve-pending-requests-button-test-id'
          disabled={totalSelectedRequests === 0}
        />
        <S.CustomButton
          title='Adiar todas pendências'
          bgColor='orange'
          hoverColor='darkOrangeHover'
          letterColor='white'
          data-testid='postpone-pending-requests-button-test-id'
          onClick={() => setShowConfirmModal(true)}
        />
        <ConfirmOrRejectModal
          show={showConfirmModal}
          title='Adiar todas pendências'
          description='Deseja realmente adiar todas as pendências?'
          onConfirm={postponePendingRequests}
          onReject={closeConfirmModal}
          onClose={closeConfirmModal}
          dataTestId='confirm-postpone-pending-requests-modal-test-id'
        />
      </S.ContainerButtons>
    </S.Container>
  )
}

export default PreviousPendingRequestForm
